import React from 'react';
import styles from './CustomerSearch.module.css';

interface CustomerSearchProps {
  value: string;
  onChange: (value: string) => void;
  activeTier: string;
  onTierChange: (tier: string) => void;
}

const tiers = ['All', 'Gold', 'Silver', 'Bronze'];

export const CustomerSearch: React.FC<CustomerSearchProps> = ({ value, onChange, activeTier, onTierChange }) => {
  return (
    <div className={styles.row}>
      <div className={styles.searchBox}>
        <svg className={styles.searchIcon} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <circle cx="11" cy="11" r="8" />
          <path d="m21 21-4.35-4.35" />
        </svg>
        <input
          className={styles.searchInput}
          type="text"
          placeholder="Search customers..."
          value={value}
          onChange={(e) => onChange(e.target.value)}
        />
      </div>
      <div className={styles.pills}>
        {tiers.map((tier) => (
          <button
            key={tier}
            className={`${styles.pill} ${activeTier === tier ? styles.pillActive : ''}`}
            onClick={() => onTierChange(tier)}
          >
            {tier}
          </button>
        ))}
      </div>
    </div>
  );
};
